import React, { useState } from "react";
import Modaal from "./modaal";
import { FormInputs } from "../inputs";
import { Row } from "react-bootstrap";

const AuthModal = ({
    bodyContent1,
    show,
    onHide,
    title,
    inputFields,
    credentials,
    handleChange,
    errors,
    footer,
    centered,
    className,

}) => {
    const [focusedField, setFocusedField] = useState(null);

    const handleFocus = (fieldName) => {
        setFocusedField(fieldName);
    };

    const renderFormContent = () => (
        <>
            <Row>
                {inputFields?.map((field, index) => (
                    <FormInputs
                        key={index}
                        label={
                            errors?.[field.name] ? (
                                <span className="form-label-error-span exado_body_text"> * {errors?.[field.name]}</span>
                            ) : (
                                focusedField === field.name && (
                                    <span className="form-label-span"> {field?.label}</span>
                                )
                            )
                        }
                        type={field.type}
                        placeholder={field.placeholder}
                        value={credentials?.[field.name] || ""}
                        onChange={handleChange}
                        controlId={`login${field.label}`}
                        name={field.name}
                        maxLength={field.maxLength}
                        onFocus={() => handleFocus(field.name)}
                        md={field.md}
                        className={errors?.[field.name] ? "form-label-error-span" : ""}
                    />
                ))}
            </Row>
        </>
    );

    return (
        <Modaal
            size="xl"
            show={show}
            onHide={onHide}
            title={title}
            bodyContent={renderFormContent()}
            bodyContent1={bodyContent1}
            footer={footer}
            centered={centered}
            className={className}
            backdrop="static"
        />
    );
};

export default AuthModal;
